import { useStylesHook } from "../hooks/useStylesHook";
export function useCheckboxGroupClasses() {
    return useStylesHook({
        input: {
            alignItems: "center",
            width: "100%",
            cursor: "pointer",
            margin: "2px 0 0 0",
        },
    });
}
